import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const IncompleteInfo = React.lazy(() => import('@/pages/USER/UpdateInfomation/IncompleteInfoForm'))
const Home = React.lazy(() => import('@/pages/ANONYMOUS/Home'))
const EnterpriseRegister = React.lazy(() => import('@/pages/ANONYMOUS/EnterpriseRegister'))

export const publicRoutes = [
  {
    path: ROUTER.CAP_NHAT_THONG_TIN,
    element: (
      <LazyLoadingComponent>
        <IncompleteInfo />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DANG_KY_DOANH_NGHIEP_WIZARD,
    element: (
      <LazyLoadingComponent>
        <EnterpriseRegister />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.HOME,
    element: (
      <LazyLoadingComponent>
        <Home />
      </LazyLoadingComponent>
    ),
  },
]
